import { Controller } from 'stimulus';
import toArray from '../helpers/toArray.ts';

class LanguageSwitch extends Controller {
  onLanguageClick(event) {
    const button = event.currentTarget;
    const language = button.getAttribute('data-language');
    const fallbackUrl = button.getAttribute('data-fallback-url');

    const urlForLanguage = this.findUrlForLanguage(language);

    // If we found a url for the clicked language (from the rel='alternate')...
    if (urlForLanguage) {
      window.location.href = urlForLanguage;
      return;
    }

    window.location.href = fallbackUrl;
  }

  // eslint-disable-next-line class-methods-use-this
  findUrlForLanguage(language) {
    const links = toArray(document.querySelectorAll('[rel="alternate"]'));

    const linksForLanguage = links.filter((link) => (
      link.getAttribute('hreflang') === language
    ));

    return linksForLanguage.length ? linksForLanguage[0].href : null;
  }
}

LanguageSwitch.targets = [
  //
];

export default LanguageSwitch;
